<script>
export default {
  name: "noResultsBanner",
  props: {
    getBannerText: {
      type: Function,
      required: true
    }
  },
  computed: {
    bannerText() {
      return this.getBannerText();
    }
  }
};
</script>

<template>
  <el-card style="width: 100%;">
    <el-row style="padding: 5px 0">
      <el-col :span="24" style="display: flex;justify-content: center;">
        <span class="no-results-available">{{ bannerText }}</span>
      </el-col>
    </el-row>
  </el-card>
</template>

<style scoped>
.no-results-available {
  color: #101010;
  font-family: DINosaur-a, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 142.857%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/noResultsBanner.vue